module.exports = __webpack_public_path__ + "img/Path 18 Copy@3x.bed91d04.png";